import { client } from "../../client";
import { AccountInfo } from "./account";

// Constants
export const SERVER_PAGE_SIZE = 100; //Server side pagination

export type AccountSearch = {
  query: string;
};

export interface AccountSearchCriteria {
  number: string | null;
  mpan: string | null;
  mprn: string | null;
  email: string | null;
  phone: string | null;
  postcode: string | null;
}

export interface AccountSearchInfo extends AccountInfo {
  criteria: AccountSearchCriteria;
}

export interface AccountSearchResult {
  results: AccountSearchInfo[];
  totalCount: number;
}

export type SearchField = keyof AccountSearch;

// API
export const searchAccounts = (
  key: string,
  { query, page }: { query: string; page: number },
) => {
  const params = { page: String(page), size: String(SERVER_PAGE_SIZE) };
  return client
    .post<AccountSearchResult>(
      `accounts/search/?${new URLSearchParams(params).toString()}`,
      { query },
    )
    .then((response) => {
      return {
        results: response?.data?.results,
        totalCount: response?.headers["x-total-count"],
      };
    });
};
